import {SIGN_OUT} from '/redux/action/auth.action';
import {
  getTestingCurrentPeriodId,
  getTestingDate,
  getTestingLastPeriodId,
  getTestingLatestAcceptedPeriodId,
  getTestingOpenPeriodId,
} from '/redux/api/storagePeriod';
import {createPromisedAction} from '/util/action.util';

export const GET_TESTING_OPTIONS: string = 'TESTING_OPTIONS/GET';
export const UPDATE_PERIOD_ID: string = 'TESTING_OPTIONS/UPDATE_PERIOD_ID';
export const UPDATE_DATE: string = 'TESTING_OPTIONS/UPDATE_DATE';
export const UPDATE_LAST_PERIOD_ID: string =
  'TESTING_OPTIONS/UPDATE_LAST_PERIOD_ID';
export const UPDATE_LATEST_ACCEPTED_PERIOD_ID: string =
  'TESTING_OPTIONS/UPDATE_LATEST_ACCEPTED_PERIOD_ID';
export const UPDATE_OPEN_PERIOD_ID: string =
  'TESTING_OPTIONS/UPDATE_OPEN_PERIOD_ID';

export const getTestingOptions = createPromisedAction(
  GET_TESTING_OPTIONS,
  [],
  dispatchMe => {
    return Promise.all([
      getTestingCurrentPeriodId(),
      getTestingDate(),
      getTestingLastPeriodId(),
      getTestingLatestAcceptedPeriodId(),
      getTestingOpenPeriodId(),
    ]).then(
      ([
        currentPeriodId,
        date,
        lastPeriodId,
        latestAcceptedPeriodId,
        openPeriodId,
      ]) =>
        dispatchMe(() => ({
          currentPeriodId,
          date,
          lastPeriodId,
          latestAcceptedPeriodId,
          openPeriodId,
        })),
    );
  },
);

export const updateCurrentPeriodId = createPromisedAction(
  UPDATE_PERIOD_ID,
  [],
  dispatchMe => {
    return getTestingCurrentPeriodId().then(currentPeriodId => {
      return dispatchMe(() => ({currentPeriodId}));
    });
  },
);
export const updateDate = createPromisedAction(UPDATE_DATE, [], dispatchMe => {
  return getTestingDate().then(date => {
    return dispatchMe(() => ({date}));
  });
});
export const updateLastPeriodId = createPromisedAction(
  UPDATE_LAST_PERIOD_ID,
  [],
  dispatchMe => {
    return getTestingLastPeriodId().then(lastPeriodId => {
      return dispatchMe(() => ({lastPeriodId}));
    });
  },
);
export const updateLatestAcceptedPeriodId = createPromisedAction(
  UPDATE_LATEST_ACCEPTED_PERIOD_ID,
  [],
  dispatchMe => {
    return getTestingLatestAcceptedPeriodId().then(latestAcceptedPeriodId => {
      return dispatchMe(() => ({latestAcceptedPeriodId}));
    });
  },
);
export const updateOpenPeriodId = createPromisedAction(
  UPDATE_OPEN_PERIOD_ID,
  [],
  dispatchMe => {
    return getTestingOpenPeriodId().then(openPeriodId => {
      return dispatchMe(() => ({openPeriodId}));
    });
  },
);

// Use reducers, that handles events
// with SIGN_OUT action type to clear storage
// and refetching data will automatically start
// with updated testing options
export const clearFetchedData = createPromisedAction(SIGN_OUT);
